import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';

export const Hero = ({ c }) => (
  <section className="px-4 sm:px-6 lg:px-8 pt-16 pb-24 lg:pt-20" data-testid="hero-section">
    <div className="max-w-6xl mx-auto grid lg:grid-cols-[1.1fr_0.9fr] gap-14 items-center">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[rgba(17,17,17,0.1)] bg-white mb-8" data-testid="hero-badge">
          <span className="w-2 h-2 rounded-full bg-[#7a5a2e]" />
          <span className="font-mono-k text-[11px] tracking-[0.25em] uppercase text-[#5f6672]">{c.hero_badge}</span>
        </span>
        <h1 className="font-display font-extrabold text-5xl sm:text-6xl lg:text-7xl leading-[0.98] tracking-tight mb-8" data-testid="hero-title">
          <span className="block text-[#111]">{c.hero_line_1}</span>
          <span className="block text-[#111]">{c.hero_line_2}</span>
          <span className="block text-[#1b3352]">{c.hero_line_3}</span>
        </h1>
        <p className="text-base md:text-lg text-[#5f6672] max-w-md leading-relaxed mb-10" data-testid="hero-subtitle">{c.hero_text}</p>
        <div className="flex flex-wrap gap-3">
          <Link to="/catalogo" className="k-btn-primary" data-testid="hero-catalog-button">
            {c.hero_btn_1} <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/personaliza" className="k-btn-ghost" data-testid="hero-custom-idea-button">
            {c.hero_btn_2} <Sparkles className="w-4 h-4" />
          </Link>
        </div>
      </motion.div>
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.15 }} className="relative h-[460px] sm:h-[520px]">
        <img src={c.hero_photo_1} alt="" className="absolute top-0 right-6 w-[78%] h-[68%] object-cover rounded-2xl shadow-[0_30px_60px_rgba(17,17,17,0.15)]" data-testid="hero-image" />
        <img src={c.hero_photo_2} alt="" className="absolute bottom-0 left-0 w-[48%] h-[44%] object-cover rounded-2xl border-4 border-white shadow-[0_30px_60px_rgba(17,17,17,0.18)]" data-testid="hero-image-2" />
        <div className="absolute bottom-10 right-0 bg-[#111] text-white rounded-xl px-5 py-4" data-testid="hero-stat">
          <div className="font-display font-bold text-2xl">{c.hero_stat_value}</div>
          <div className="font-mono-k text-[10px] tracking-[0.25em] uppercase text-white/60">{c.hero_stat_label}</div>
        </div>
      </motion.div>
    </div>
  </section>
);
